import { supabase } from "../../Services/supabaseClient";

export const getCrmForecastSummary = async (companyId) => {
  const { data, error } = await supabase
    .from("crm_opportunities")
    .select(
      "id, name, amount, probability, expected_close_date, status, forecast_category"
    )
    .eq("company_id", companyId);

  if (error) {
    throw error;
  }

  const rows = data || [];

  const grouped = rows.reduce((accumulator, row) => {
    const key = row.expected_close_date
      ? row.expected_close_date.slice(0, 7)
      : "Unscheduled";

    if (!accumulator[key]) {
      accumulator[key] = {
        period: key,
        pipeline: 0,
        weighted: 0,
        committed: 0,
        won: 0,
      };
    }

    accumulator[key].pipeline += Number(row.amount || 0);
    accumulator[key].weighted +=
      (Number(row.amount || 0) * Number(row.probability || 0)) / 100;

    if (row.forecast_category === "commit") {
      accumulator[key].committed += Number(row.amount || 0);
    }

    if (row.status === "won") {
      accumulator[key].won += Number(row.amount || 0);
    }

    return accumulator;
  }, {});

  return Object.values(grouped).sort((left, right) =>
    String(left.period).localeCompare(String(right.period))
  );
};
